import { DateRange } from '@angular/material/datepicker';
import moment from 'moment';

export const PH_DATEPICKER_API_FORMAT = 'YYYY-MM-DD';

export type ApiDateRange = { date_from: string; date_to: string };

export function formatApiDate(value: moment.Moment | Date | string): string {
	if (value == null || value === '') return null;
	const m = moment(value);
	return m.isValid() ? m.format(PH_DATEPICKER_API_FORMAT) : null;
}

export function sessionDateLimits(defaults: { date_from?: string; date_to?: string }): ApiDateRange {
	if (!defaults?.date_from || !defaults?.date_to) {
		return { date_from: '', date_to: '' };
	}
	const dateFrom = formatApiDate(defaults.date_from);
	const dateTo = formatApiDate(defaults.date_to);
	if (!dateFrom || !dateTo) {
		return { date_from: '', date_to: '' };
	}
	return { date_from: dateFrom, date_to: dateTo };
}

export function toApiDateRange(data: Date | DateRange<Date>): ApiDateRange {
	if (!data) return null;
	const range = data instanceof Date ? new DateRange(data, data) : data;
	if (!range.start) return null;
	const dateFrom = formatApiDate(range.start);
	const dateTo = formatApiDate(range.end ?? range.start);
	if (!dateFrom || !dateTo) return null;
	return { date_from: dateFrom, date_to: dateTo };
}

export function toDateRangeString(date_from: string, date_to: string): DateRange<string> {
	return new DateRange(date_from, date_to);
}
